import { SIZE } from '@app/constants'

import type { TablePaginationConfig } from 'antd'

export const defaultPagination: TablePaginationConfig = {
  showTotal: (total: number): string => `К-во записей: ${total}`,
  pageSizeOptions: [10, 50, 100, 500, 1000],
  showSizeChanger: true,
  size: SIZE.small
}

export const DEFAULT_TABLE_SCROLL_Y = 700
export const TABLE_HEADER_HEIGHT_FALLBACK = 55
export const MIN_TABLE_SCROLL_Y = 100
